import { render } from "./TempSavedImplantsHospital.vue?vue&type=template&id=951671d8&scoped=true"
import script from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"
export * from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"

import "./TempSavedImplantsHospital.vue?vue&type=style&index=0&id=951671d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951671d8"]])

export default __exports__